import React from "react";
import { Loader2, RefreshCw, Sparkles, ArrowRight } from "lucide-react";
import { btnPrimary, registrarShort, resultsSourceLabel } from "./onboardShared";

function ResultRow({ r, checked, onToggle }) {
  return (
    <label data-testid={`domains-result-${r.domain}`} className={`flex items-center gap-3 px-4 py-2.5 text-sm ${r.available ? "cursor-pointer hover:bg-zinc-900/40" : "opacity-50"}`}>
      <input type="checkbox" data-testid={`domains-select-${r.domain}`} disabled={!r.available} checked={checked} onChange={onToggle} />
      <span className={`dot ${r.available ? "bg-emerald-500" : "bg-zinc-600"}`} />
      <span className="mono flex-1">{r.domain}{r.is_premium && <span className="ml-2 text-[10px] mono uppercase px-1.5 py-0.5 bg-amber-500/10 text-amber-400 border border-amber-500/30 rounded-sm">premium</span>}</span>
      <span className="mono text-xs text-zinc-400" title={r.renewal_usd != null ? `renews at $${r.renewal_usd.toFixed(2)}/yr` : ""}>
        ${(r.price_usd || 0).toFixed(2)}/yr
        {r.min_years > 1 && <span data-testid={`domains-minterm-${r.domain}`} className="ml-1.5 text-amber-300" title={`${r.min_years}-year minimum term for this TLD`}>· {r.min_years}yr min = ${(r.total_usd || 0).toFixed(2)}</span>}
      </span>
      <span className="w-32 text-right truncate">{!r.available && <span className="text-[11px] text-zinc-600 uppercase" title={r.reason || ""}>{r.reason_label || "taken"}</span>}</span>
    </label>
  );
}

function GenerateAgain({ buy, selectedList }) {
  return (
    <div className="flex items-center gap-1.5">
      <button data-testid="domains-regenerate-btn" onClick={() => buy.doGenerate()} disabled={buy.generating} className="inline-flex items-center gap-1 text-[11px] font-semibold text-zinc-300 hover:text-white border border-zinc-700 hover:border-zinc-500 px-2 py-1 rounded-sm">
        {buy.generating ? <Loader2 size={12} className="animate-spin" /> : <RefreshCw size={12} />} Shuffle again
      </button>
      <button data-testid="domains-morelike-btn" onClick={() => buy.doGenerate(selectedList)} disabled={buy.generating || selectedList.length === 0} title="Uses your selected names as style seeds" className="inline-flex items-center gap-1 text-[11px] font-semibold text-amber-300 hover:text-white border border-amber-500/40 hover:border-amber-400 bg-amber-500/10 px-2 py-1 rounded-sm disabled:opacity-40">
        <Sparkles size={12} /> More like selected
      </button>
    </div>
  );
}

/** Availability / suggestion / generator results with multi-select and running total. */
export function ResultsTable({ w }) {
  const { buy, selected, selectedList, selectedTotal, toggleDomain, toReview } = w;
  const results = buy.results;
  return (
    <div className="border border-zinc-800 rounded-sm overflow-hidden">
      <div className="flex items-center justify-between bg-zinc-900/70 border-b border-zinc-800 px-4 py-2">
        <div className="label-tiny">{results.filter((r) => r.available).length} available · {results.length} {resultsSourceLabel(buy.resultsSource)} · via {registrarShort(buy.registrar)}</div>
        <div className="flex items-center gap-3">
          {buy.resultsSource === "generate" && <GenerateAgain buy={buy} selectedList={selectedList} />}
          <div className="text-xs text-zinc-400">Selected <b className="text-white">{selectedList.length}</b> · <span className="mono text-amber-300">${selectedTotal.toFixed(2)}</span></div>
        </div>
      </div>
      <div className="divide-y divide-zinc-800 max-h-[340px] overflow-y-auto">
        {results.map((r) => <ResultRow key={r.domain} r={r} checked={selected.has(r.domain)} onToggle={() => toggleDomain(r.domain)} />)}
      </div>
      <div className="flex items-center justify-end border-t border-zinc-800 px-4 py-3">
        <button data-testid="domains-to-review-btn" onClick={toReview} disabled={selectedList.length === 0} className={btnPrimary}>Configure {selectedList.length || ""} <ArrowRight size={15} /></button>
      </div>
    </div>
  );
}
